const PERMISSION_KEY= "crm:zone";
const PAGE_URL = {
    ZONE_PAGE: "/admin/crm/zone"
}

export {PERMISSION_KEY, PAGE_URL}

